import { request } from "apis/base";
import {
  PurchaseOrderCreateBodyType,
  PurchaseOrderUpdateBodyType,
} from "constants/types/purchaseOrder";

export const purchaseOrderApi = {
  getById: (id: string) => {
    return request({ url: `/purchase-order/${id}`, method: "GET" });
  },

  create: (data: PurchaseOrderCreateBodyType) => {
    return request({ url: "/purchase-order", method: "POST", data });
  },

  update: (id: string, data: PurchaseOrderUpdateBodyType) => {
    return request({ url: `/purchase-order/${id}`, method: "PATCH", data });
  },

  delete: (id: string) => {
    return request({ url: `/purchase-order/${id}`, method: "DELETE" });
  },
};
